document.addEventListener('DOMContentLoaded', () => {
    const arrowElementGrid = document.querySelectorAll('.section--revolutinize-your-recovery .element-grid .arrow');
    const elementGrid = document.querySelectorAll('.section--revolutinize-your-recovery .element-grid');
  
    elementGrid.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        // Verifica si el botón ya tiene la clase "active"
        if (btn.classList.contains('active')) {
          btn.classList.remove('active')
          elementGrid[index].classList.remove('active')
        } else {
          // Elimina la clase "active" de todos los botones y contenedores
          arrowElementGrid.forEach((btn) => {
            btn.classList.remove('active')
          });
          elementGrid.forEach((container) => {
            container.classList.remove('active')
          });
  
          // Agrega la clase "active" al botón y contenedor correspondientes
          btn.classList.add('active')
          elementGrid[index].classList.add('active')
        };
      });
    });
});
  
